import { useTranslation } from "react-i18next";

export enum LEASE_OPTIONS {
  All = "all",
  Lease = "lease",
  NoLease = "no_lease"
}

export const useLeaseCompanyOptions = () => {
  const { t } = useTranslation();

  const leaseCompanyOptions = [
    { key: LEASE_OPTIONS.All, value: LEASE_OPTIONS.All, text: t("v8_all", "All"), filterValue: null },
    { key: LEASE_OPTIONS.Lease, value: LEASE_OPTIONS.Lease, text: t("v8_lease", "Lease"), filterValue: true },
    { key: LEASE_OPTIONS.NoLease, value: LEASE_OPTIONS.NoLease, text: t("v8_no_lease", "No Lease"), filterValue: false }
  ];

  return { leaseCompanyOptions };
};
